<div class="label-wrapper">
  <ng-content select="[prefix]"></ng-content>
  <input
    type="checkbox"
    [id]="id"
    [ngModel]="selected"
    [indeterminate]="indeterminate"
    [attr.data-testid]="automationKey"
    (change)="checkboxChangeHandler($event.target!)"
  />
  <ng-content select="[inside]"></ng-content>
  <label [for]="id">
    <span class="label">{{ label }}</span>
  </label>
  <ng-content select="[suffix]"></ng-content>
</div>
